/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSocialPostResponse
 */
export interface EarnSocialPostResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EarnSocialPostResponse
     */
    claimed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EarnSocialPostResponse
     */
    alreadyClaimed: boolean;
    /**
     * End-user-facing copy when the post did not verify.
     * @type {string}
     * @memberof EarnSocialPostResponse
     */
    message?: string;
    /**
     * The member's per-period cap was already full; nothing was claimed or credited.
     * @type {boolean}
     * @memberof EarnSocialPostResponse
     */
    capReached?: boolean;
}

/**
 * Check if a given object implements the EarnSocialPostResponse interface.
 */
export function instanceOfEarnSocialPostResponse(value: object): value is EarnSocialPostResponse {
    if (!('claimed' in value) || value['claimed'] === undefined) return false;
    if (!('alreadyClaimed' in value) || value['alreadyClaimed'] === undefined) return false;
    return true;
}

export function EarnSocialPostResponseFromJSON(json: any): EarnSocialPostResponse {
    return EarnSocialPostResponseFromJSONTyped(json, false);
}

export function EarnSocialPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSocialPostResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimed': json['claimed'],
        'alreadyClaimed': json['alreadyClaimed'],
        'message': json['message'] == null ? undefined : json['message'],
        'capReached': json['capReached'] == null ? undefined : json['capReached'],
    };
}

export function EarnSocialPostResponseToJSON(json: any): EarnSocialPostResponse {
    return EarnSocialPostResponseToJSONTyped(json, false);
}

export function EarnSocialPostResponseToJSONTyped(value?: EarnSocialPostResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimed': value['claimed'],
        'alreadyClaimed': value['alreadyClaimed'],
        'message': value['message'],
        'capReached': value['capReached'],
    };
}

